<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <crop-price-statistics />
  </b-container>
</template>
<script>

import { core } from '@/config/pluginInit'

import CropPriceStatistics from '@/components/dashboard/CropPriceStatistics.vue'

export default {
  name: 'ManagerGraphCropPrice',
  middleware: ['auth', 'manager'],
  components: {
    CropPriceStatistics
  },

  metaInfo () {
    return {
      title: 'Crop Prices Graph'
    }
  },

  mounted () {
    core.index()
  }

}
</script>
